import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
  crawlFacebook,
  getCrawlStatus,
  getCrawlFbList,
  getGiftRecommendations,
  CrawlFbPayload,
  CrawlFbResponse,
  CrawlFbStatus,
  GiftRecommendationResponse,
  deleteCrawlFb,
} from '../api/crawlFb';

export const useCrawlFb = () => {
  return useMutation({
    mutationFn: async (payload: CrawlFbPayload): Promise<CrawlFbResponse> => {
      return await crawlFacebook(payload);
    },
    onSuccess: (data) => {
      toast.success('Gửi request thành công!');
      return data;
    },
    onError: (error: Error) => {
      toast.error('Lỗi kết nối: ' + error.message);
    },
  });
};

export const useGetCrawlStatus = (
  id: string | null,
  enabled: boolean = false
) => {
  return useQuery({
    queryKey: ['crawl-status', id],
    queryFn: () => getCrawlStatus(id!),
    enabled: enabled && !!id,
    refetchInterval: (query) => {
      const data = query.state.data;
      // Stop polling when status is completed or failed
      if (
        data?.status === CrawlFbStatus.COMPLETED ||
        data?.status === CrawlFbStatus.FAILED
      ) {
        return false;
      }
      // Poll every 3 seconds for pending/processing status
      return 3000;
    },
    refetchIntervalInBackground: true,
  });
};

export const useCrawlFbList = ({
  page,
  limit,
}: {
  page: number;
  limit: number;
}) => {
  return useQuery<{ crawls: CrawlFbResponse[]; total: number; pages: number }>({
    queryKey: ['crawl-fb-list', page, limit],
    queryFn: async () => {
      const response = await getCrawlFbList(page, limit);
      return {
        crawls: response.items,
        total: response.totalItems,
        pages: response.totalPages,
        hasNextPage: response.hasNextPage,
      };
    },
    placeholderData: (previousData) => previousData,
  });
};

export const useGetGiftRecommendations = () => {
  return useMutation({
    mutationFn: async (
      idCrawl: string
    ): Promise<GiftRecommendationResponse> => {
      return await getGiftRecommendations(idCrawl);
    },
    onSuccess: () => {
      toast.success('Lấy gợi ý quà tặng thành công!');
    },
    onError: (error: Error) => {
      toast.error('Lỗi khi lấy gợi ý quà tặng: ' + error.message);
    },
  });
};

export const useDeleteCrawlFb = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      return await deleteCrawlFb(id);
    },
    onSuccess: () => {
      toast.success('Xóa crawl thành công!');
    },
    onError: (error: Error) => {
      toast.error('Lỗi khi xóa crawl: ' + error.message);
    },
  });
};
